import { ContentfulLearningPath } from 'src/graphql/queries/GetLearningPath';
import { ContentfulSmCourse } from 'src/graphql/queries/GetSmCourse';
import { GetLearningPathId } from 'src/graphql/queries/GetLearningPathId';

export type ContentHeaderData = {
  title: string;
  tagline?: string;
  product?: string[];
  productRole?: string[];
};

export const getContentHeaderContent = (
  content: ContentfulLearningPath | GetLearningPathId | ContentfulSmCourse,
  isLearningPath: boolean,
): ContentHeaderData => {
  if (isLearningPath) {
    const learningPath = content as ContentfulLearningPath;

    return {
      title: learningPath.title ?? '',
      tagline: learningPath.learningPathTagline ?? '',
      product: learningPath.product ?? [],
      productRole: learningPath.productRole ?? [],
    };
  }

  const course = content as ContentfulSmCourse;

  return {
    title: course.title ?? '',
    tagline: course.teaser ?? '',
    product: course.product ?? [],
    productRole: course.productRole ?? [],
  };
};
